module.exports = __webpack_public_path__ + "media/images/star-on-ebc31ffbcb0549b4bbd3394d805fb6c1.svg";